export type CategoryDto = {
  id: number;
  name: string;
  connected_id?: number | null;
};

export type CategoryModel = {
  id: number;
  name: string;
  connectedId?: number | null;
};

export const mapCategoryDtoToModel = (dto: CategoryDto): CategoryModel => ({
  id: dto.id,
  name: dto.name,
  connectedId: dto.connected_id,
});
